'use client'
import { googleLogout, useGoogleLogin } from "@react-oauth/google";
import useUpdateGameData from "../games/helpers/useUpdateGameData";
import { useEffect, useState } from "react";
// import { UserModel } from "@/db/schema";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useAuth } from "@/contexts/AuthContext";
import { useRouter } from 'next/navigation';
import { UserModel } from "@/db/schema";

const useUserAuthentication = () => {
    const router = useRouter();
    const { user, setUser, token, setToken, profile, setProfile, redirect, setRedirect } = useAuth();

    // const [ user, setUser ] = useState<User | null>(null);
    // const [ token, setToken ] = useState<string | null>(null);
    // const [ profile, setProfile ] = useState<UserModel | null>(null);
    // const [ redirect, setRedirect ] = useState<string | null>(null);
    const [ baseUrl, setBaseUrl ] = useState<string | null>(null);
    const [ code, setCode ] = useState<string | null>(null);
    const [ service, setService ] = useState<string | null>(null);
    const { updateGameData } = useUpdateGameData();

    useEffect(() => {
        setBaseUrl(window.location.origin);
    }, []);

    useEffect(() => {
        const tokenString = localStorage.getItem('user.auth.token');
        const profileString = localStorage.getItem('user.auth.profile');
        const token = tokenString ? JSON.parse(tokenString) : null;
        const profile = profileString ? JSON.parse(profileString) as UserModel : null;
        if (token) {
            setToken(token);
        }

        if (profile) {
            setProfile(profile);
        }
    }, [setProfile, setToken]);

    useEffect(() => {
        if (user || code) {
            const url = `${baseUrl ? `${baseUrl}/api/` : process.env.NEXT_PUBLIC_API_URL}auth/signin`;
            let body;
            if (user) {
                body = JSON.stringify(user);
            } else {
                body = JSON.stringify({ code, redirect_uri: baseUrl ? `${baseUrl}/oauth2/${service}` : process.env.NEXT_PUBLIC_DISCORD_REDIRECT, service });
            }

            if (localStorage.getItem('user.auth.profile')) {
                return;
            }

            fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body,
            })
            .then((res) => {
                return res.json();
            })
            .then(async (data) => {
                if (data.responseCode === 1) {
                    setProfile(data.user);
                    setToken(data.token);
                    if (user?.service === 'orca') {
                        withReactContent(Swal).fire({
                            title: <><img src="/assets/image/orca_logo_128x80.png" alt="ORCA" className="mx-auto" /></>,
                            html: 'Sign In Successful.',
                            icon: 'success',
                            timer: 2000,
                            theme: 'dark'
                        });
                    }
                    localStorage.setItem('user.auth.token', JSON.stringify(data.token));
                    localStorage.setItem('user.auth.profile', JSON.stringify(data.user));
                    localStorage.setItem('user.auth.google.session', JSON.stringify(user, (key, value) => key === 'password' ? undefined : value));
                    const authRedirect = localStorage.getItem('user.auth.redirect');
                    if (authRedirect) {
                        setRedirect(authRedirect);
                        localStorage.removeItem('user.auth.redirect');
                        return router.push(authRedirect);
                    }

                    const historyString = localStorage.getItem('guest.games.histories');
                    if (historyString) {
                        let lastGameId = '';
                        let shareHash = '';
                        const historyString = localStorage.getItem('guest.games.histories');
                        const savedHistories = historyString ? JSON.parse(historyString) : null;
                        for (const savedHistory of savedHistories) {
                            const updateData = await updateGameData({ ...savedHistory, token: data.token });
                            if (updateData && updateData.success) {
                                lastGameId = savedHistory.gameid;
                                shareHash = updateData.hash;
                            }
                        }

                        localStorage.removeItem('guest.games.histories');

                        if (shareHash.length > 0) {
                            return setRedirect(`/game/${lastGameId}/share/${shareHash}`);
                        }
                    }
                    if (redirect) {
                        router.push(redirect);
                    } else if (code) {
                        setRedirect(`/`);
                    }
                    if (window.location.href.indexOf('/game/') !== -1) {
                        router.refresh();
                    }
                } else {
                    if (user?.service === 'orca') {
                        withReactContent(Swal).fire({
                            title: <><img src="/assets/image/orca_logo_128x80.png" alt="ORCA" className="mx-auto" /></>,
                            html: 'Sign In Failed!',
                            icon: 'error',
                            timer: 2000,
                            theme: 'dark'
                        });
                    }
                }
            })
            .catch((err) => {
                setRedirect(`/`);
                console.log(err);
            });
        }
    }, [user, code]);

    const logIn = (service: string | null = 'google', data: object | string | null = null, redirect: string | null = null) => {
        if (redirect) {
            localStorage.setItem('user.auth.redirect', redirect);
        } else {
            localStorage.removeItem('user.auth.redirect');
        }

        if (service === 'discord') {
            document.location = baseUrl ? `https://discord.com/oauth2/authorize?client_id=${process.env.NEXT_PUBLIC_DISCORD_CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(`${baseUrl}/oauth2/discord`)}&scope=identify` : process.env.NEXT_PUBLIC_DISCORD_URL??'';
            setService('discord');
        } else if (service === 'orca') {
            let usernameInput: HTMLInputElement | null;
            let passwordInput: HTMLInputElement | null;
            withReactContent(Swal).fire({
                title: <><img src="/assets/image/orca_logo_128x80.png" alt="ORCA" className="mx-auto" /></>,
                html: `
                    <input type="text" id="username" class="swal2-input" placeholder="Cadet No.">
                    <input type="password" id="password" class="swal2-input" placeholder="Password">
                `,
                confirmButtonText: 'Sign in',
                showCancelButton: true,
                focusConfirm: false,
                showLoaderOnConfirm: true,
                didOpen: () => {
                    const popup = Swal.getPopup()
                    if (popup != null) {
                        usernameInput = popup.querySelector('#username');
                        passwordInput = popup.querySelector('#password');
                        (usernameInput as HTMLInputElement).onkeyup = (event) => event.key === 'Enter' && Swal.clickConfirm();
                        (passwordInput as HTMLInputElement).onkeyup = (event) => event.key === 'Enter' && Swal.clickConfirm();
                    }
                  },
                preConfirm: async () => {
                    const cadet_no = usernameInput?.value
                    const password = passwordInput?.value
                    if (!cadet_no || !password) {
                        Swal.showValidationMessage(`Please enter Cadet No. and Password`);
                        return;
                    }

                    setUser({ cadet_no, password, service });

                    const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
                    await delay(5000);
                },
                theme: 'dark'
              });
        } else if (service === 'facebookoauth2') {
            document.location = baseUrl ? `https://www.facebook.com/v25.0/dialog/oauth?client_id=${process.env.NEXT_PUBLIC_FACEBOOK_CLIENT_ID}&redirect_uri=${encodeURIComponent(`${baseUrl}/oauth2/facebookoauth2`)}` : process.env.NEXT_PUBLIC_FACEBOOK_URL??'';
            setService('facebookoauth2');
        } else if (service === 'facebook') {
            setUser({ user: data, service });
        } else {
            googleLogIn();
        }
    }

    const googleLogIn = useGoogleLogin({
        onSuccess: (codeResponse) => { setUser({ ...codeResponse, service: 'google' }); },
        onError: (error) => console.log('Login Failed:', error),
    });

    const logOut = () => {
        googleLogout();
        if (token) {
            const url = `${baseUrl ? `${baseUrl}/api/` : process.env.NEXT_PUBLIC_API_URL}auth/signout`;
            fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type' : 'application/json' },
                    body: JSON.stringify({token}),
                })
                .then((res) => {
                    return res.json();
                })
                .then(async (data) => {
                    if (data.responseCode === 1) {
                    }
                    // console.log(data);
                })
                .catch((err) => console.log(err));
        }
        localStorage.removeItem('user.auth.token');
        localStorage.removeItem('user.auth.profile');
        localStorage.removeItem('user.auth.google.session');
        setProfile(null);
        router.refresh();
    };

    const setDoneRedirection = () => {
        setRedirect(null);
    }


    return {
        logIn,
        logOut,
        profile,
        token,
        redirect,
        setCode,
        setService,
        setDoneRedirection
    }
}

export default useUserAuthentication;